<div class="paywall-contact-success">
  <h2>Request sent</h2>
  <p>We will get back to {{ paywallService.contactEmail() }}.</p>
</div>
